/* istanbul ignore file */
export const noop = () => {};
